import React from "react";
import { ArrowDown, Layers2, Thermometer, Flame, Gauge, Wrench, Leaf } from "lucide-react";
import { THERMAL_FACTS } from "../mock";

const ICONS = { Flame, Gauge, Wrench, Leaf };

export const ThermalFlow = ({ tid }) => (
  <div className="thermal-flow" data-testid={tid("pyro-outputs")}>
    <svg className="thermal-connector" viewBox="0 0 40 368" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 176H11Q20 176 20 163V46Q20 34 32 34H40" fill="none" stroke="var(--oil)" strokeWidth="1.5" className="flow-line" />
      <path d="M0 190H10Q20 190 20 207V352H40" fill="none" stroke="var(--green-light)" strokeWidth="1.2" />
    </svg>
    <div className="thermal-content">
      <div className="thermal-card" data-testid={tid("pyro-outputs-unified")}>
        <div className="thermal-card-heading">
          <div>
            <span className="process-eyebrow" data-testid={tid("thermal-circuit-label")}>Salida 1 · Energía térmica</span>
            <h3 data-testid={tid("pyro-output-thermal-oil")}>Calor entregado en planta</h3>
          </div>
          <Thermometer size={24} strokeWidth={1.4} aria-hidden="true" />
        </div>
        <ul className="thermal-facts" data-testid={tid("thermal-facts")}>
          {THERMAL_FACTS.map((f, i) => {
            const Icon = ICONS[f.icon];
            return <li key={f.title} data-testid={tid(`thermal-fact-${i}`)}>
              <Icon size={15} strokeWidth={1.5} aria-hidden="true" />
              <span><strong>{f.title}</strong> {f.text}</span>
            </li>;
          })}
        </ul>
      </div>
      <div className="biochar-secondary" data-testid={tid("pyro-output-biochar")}>
        <Layers2 size={18} strokeWidth={1.4} aria-hidden="true" /><strong>Salida 2 · Biochar</strong><span>Carbono estable que vuelve al campo</span><ArrowDown size={15} aria-hidden="true" />
      </div>
    </div>
  </div>
);
